(() => {
  const copy = document.getElementById('MfxReviewCopy');
  if (!copy) return;
  let queued = false;
  function setText(element, value) {
    if (element && value && element.textContent !== value) element.textContent = value;
  }
  function refresh() {
    queued = false;
    document.querySelectorAll('#AirReviews-BlockWrapper').forEach(widget => {
      const count = widget.querySelector('.AirReviews-Blocks--ReviewCount span');
      const total = count ? Number(count.textContent.trim()) : NaN;
      widget.dataset.mfxEmpty = Number.isFinite(total) && total === 0 ? 'true' : 'false';
      setText(widget.querySelector('.AirReviews-Blocks--Title'), copy.dataset.title);
      setText(widget.querySelector('.AirReviews-Blocks--Actions__Text'), copy.dataset.action);
      const empty = widget.querySelector('.AirReviews-NoReview__Content .AirReviews-Text--bodySm');
      if (widget.dataset.mfxEmpty === 'true') setText(empty, copy.dataset.empty);
      setText(widget.querySelector('.AirReviews-Blocks__ActionRate legend'), copy.dataset.stars);
    });
    document.querySelectorAll('.AirReviews-Modal').forEach(modal => {
      const title = modal.querySelector('.AirReviews-Modal__Title');
      if (title && ['Tell us about your reviews', copy.dataset.dialogTitle].includes(title.textContent)) setText(title, copy.dataset.dialogTitle);
      const close = modal.querySelector('.AirReviews-Modal__Close');
      if (close && copy.dataset.close) close.setAttribute('aria-label', copy.dataset.close);
      setText(modal.querySelector('.AirReviews-Blocks__ActionRate legend'), copy.dataset.stars);
    });
  }
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return target?.closest('#AirReviews-BlockWrapper, .AirReviews-Modal') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'AirReviews-BlockWrapper' || node.matches?.('.AirReviews-Modal') || node.querySelector?.('#AirReviews-BlockWrapper, .AirReviews-Modal')));
    });
    if (relevant && !queued) {
      queued = true;
      requestAnimationFrame(refresh);
    }
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  refresh();
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
